import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";

const useStackTasksAnalytics = () => {
  return useAnalytics({ page: AnalyticsPageStack.StacksTaskList });
};

export default useStackTasksAnalytics;
